import { TemplatePage } from './types';

const videoGamePage: TemplatePage = {
  header: {
    color: '#D4E6F0',
    icon: 'images/video-templates/videogame.jpg',
    title: 'Video Game Templates',
    title_meta: 'Free Video Game Templates',
    description_meta:
      'Create captivating videos for your streaming channel or gaming vlog in minutes. Try free.',
    description:
      'Use these free video templates to promote your gaming vlog, streaming channel, or video reviews website through ' +
      'video. These templates are optimized for all social media platforms and are perfect for gamers and gaming businesses.'
  },
  footer: {
    category: 'Video Game',
    description:
      'Do you want to make engaging videos but not know where to start? These ready-made video templates are perfect for ' +
      'beginners and do not require any editing skills. Simply select a template you like, replace the text, upload your logo, ' +
      'and add a compelling CTA to subscribe to your channel or visit your website. '
  },
  content: [
    {
      type: 'templates',
      title: 'Video Game Templates',
      search: { name: 'video game' }
    },
    {
      type: 'stocks',
      title: 'video game',
      search: { name: 'video game' }
    },
    { type: 'calendar' }
  ]
};

export default videoGamePage;
